module.exports = __webpack_public_path__ + "img/Pollinators_DNR_HQ.8fc2021.jpg";